export enum EServerStyle {
  info = 'info',
  alert = 'alert',
  join = 'join',
  left = 'left',
  notActive = 'notActive'
};

export interface IData {
  event: string;
  audioNotification: boolean;
  user: IUser;
  oldRoomId?: string;
  room: IChatRoom | null;
  message?: IMessage;
}

export interface IModeration {
  event: string;
  roomId: string;
  messageId: string;
  messageText: string;
  isModerated?: boolean;
}

export interface IBanWarning {
  event: string;
  message: string;
}

export interface IDataInvite {
  inviteId: string,
  fromUser?: {
    id: string,
    name: string,
    gender?: string,
    avatar?: string | null,
  }
  toUser?: {
    id: string,
    name: string,
    avatar?: string | null,
  }
  time: string
  message?: IMessage
}

export interface IWebRTCData {
  event: string,
  initiatorId: string,
  partnerId: string,
  roomId: string,
  session: RTCSessionDescriptionInit | null,
}

export interface ICallSession {
  event: string,
  initiatorId: string,
  initiatorName: string,
  partnerId: string,
  partnerName: string,
  roomId: string,
  isUserBusy?: boolean,
  session?: RTCSessionDescriptionInit | null,
}

export interface IUser {
  id: string;
  name: string;
  gender: string;
  deviceType: "mobile" | "desktop";
  time: string;
  rooms: IChatRoom[] | null;
  ws?: any | null;
  avatar?: string | null;
};

export interface IAvatarItem {
  id: string;
  url: string;
  createdAt?: string;
}

export interface IAuthUser {
  id: string;
  nick: string;
  email: string;
  gender: string;
  role: string;
  avatarUrl?: string | null;
  avatars?: IAvatarItem[];
  avatarIndex?: number | null;
  isBanned?: boolean;
};

// Aktywna sesja/urządzenie konta (lista w /profile). Sesje master są ukryte i tu nie trafiają.
export interface ISession {
  id: string;
  deviceId: string;
  deviceInfo: string;
  userAgent: string;
  ipAddress: string;
  createdAt: string;
  lastUsedAt: string;
  current: boolean;
};

export interface IUserStorage {
  id: string;
  name: string;
  gender: string;
  deviceType: "mobile" | "desktop";
  time: string;
  rooms: IChatRoom[] | null;
  avatar?: string | null;
};

export interface IChatUser {
  id: string;
  name: string;
  gender: string;
  deviceType: "mobile" | "desktop";
  status?: 'active' | 'inactive';
  avatar?: string | null;
  role?: string;
};

export interface IMessage {
  id: string;
  roomId: string;
  isMine: boolean;
  serverTime: string;
  serverText: string;
  serverStyle: EServerStyle;
  userText: string;
  userId: string;
  userName: string;
  userAvatar?: string | null;
  userRole?: string;
  isModerated?: boolean;
  reactions?: { [emojiId: string]: string[] };
};

export interface IChatRoom {
  id: string;
  name: string;
  public?: boolean;
  private?: boolean;
  userInitiator?: IUser;
  isPendingRoom?: boolean,
  label?: string;
  region?: string;
  users: IUser[] | null;
  messages?: IMessage[];
  usersCount?: number;
  unreadCount?: number;
}

export interface IDataRoomsCount {
  event: string,
  roomCounts: [{
    room: string,
    count: number
  }]
}

export interface IRoomProps {
  data: IChatRoom;
  goToChat: (roomId: string) => void;
}

export interface ISidebar {
  id: string;
  name: string;
}

export type RouletteStatus = 'idle' | 'waiting' | 'matched';

export interface IRouletteFilters {
  roomFilter: string;    // 'any' lub id pokoju z `publicRooms`
  genderFilter: 'any' | 'male' | 'female';
}

export interface IRouletteState {
  status: RouletteStatus;
  partner: IUser | null;
  roomId: string | null;
  isInitiator: boolean;
  filters: IRouletteFilters;
}